import { Typography } from '@altibox/design-system-component-lib';
import { css, styled } from 'styled-components';

import { colorGuidance700, colorGuidance800, colorNeutral, colorSecondary400 } from 'app/style/colors';
import { focus, focusDark } from 'app/style/mixins';

import { LinkProps, LinkTheme } from './types';

const darkThemeForLink = css`
    font-weight: bold;
    color: ${colorNeutral};

    &:hover {
        color: ${colorSecondary400};
    }

    ${focusDark}
`;

const lightThemeForLink = css`
    color: ${colorGuidance700};

    &:hover {
        color: ${colorGuidance800};
    }

    ${focus}
`;

export const StyledLink = styled(Typography)<LinkProps>`
    ${(props) => {
        switch (props.$focusTheme) {
            case LinkTheme.LIGHT:
                return lightThemeForLink;
            case LinkTheme.DARK:
                return darkThemeForLink;
            default:
                return lightThemeForLink;
        }
    }}
`;
